
const appSpinner = window.document.getElementById('appSpinner');

export const toggleSpinner = (state) => {
  appSpinner.style.display = state ? 'block' : 'none';
};
